import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
}

export const MessageSquareIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.text.primary,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M3.625 21.7002L4.09352 22.2858L4.09354 22.2858L3.625 21.7002ZM6.45216 19.4383L6.9207 20.0239L6.45216 19.4383ZM17 3V3.75C19.3472 3.75 21.25 5.65279 21.25 8H22H22.75C22.75 4.82436 20.1756 2.25 17 2.25V3ZM22 8H21.25V14H22H22.75V8H22ZM22 14H21.25C21.25 16.3472 19.3472 18.25 17 18.25V19V19.75C20.1756 19.75 22.75 17.1756 22.75 14H22ZM17 19V18.25H7.7016V19V19.75H17V19ZM6.45216 19.4383L5.98361 18.8527L3.15646 21.1146L3.625 21.7002L4.09354 22.2858L6.9207 20.0239L6.45216 19.4383ZM3.625 21.7002L3.15648 21.1145C2.99305 21.2453 2.75 21.1289 2.75 20.9189H2H1.25C1.25 22.386 2.94742 23.2027 4.09352 22.2858L3.625 21.7002ZM2 20.9189H2.75V8H2H1.25V20.9189H2ZM2 8H2.75C2.75 5.65279 4.65279 3.75 7 3.75V3V2.25C3.82436 2.25 1.25 4.82436 1.25 8H2ZM7 3V3.75H17V3V2.25H7V3ZM7.7016 19V18.25C7.07712 18.25 6.47124 18.4625 5.98361 18.8527L6.45216 19.4383L6.9207 20.0239C7.14235 19.8466 7.41775 19.75 7.7016 19.75V19Z"
      fill={color}
    />
    <circle cx="7.05078" cy="11.0498" r="1.25" fill={color} />
    <circle cx="12.0508" cy="11.0498" r="1.25" fill={color} />
    <circle cx="17.0508" cy="11.0498" r="1.25" fill={color} />
  </svg>
)

MessageSquareIcon.displayName = 'MessageSquareIcon'
